import Vue from 'vue'
import VueMeta from 'vue-meta'
import store from '@/store'

Vue.use(VueMeta, {
  keyName: 'meta'
})

export default {
  titleTemplate (title) {
    const titles = []
    if (title) {
      titles.push(title)
    }
    const orgname = store.getters['org/name']
    if (orgname) {
      titles.push(orgname)
    }
    return titles.join(' | ')
  }
}
